export const GROUP_EDITOR = '/group-editor';
